import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

export function useListarProfissoes() {
  const fetchData = async () => {
    const LISTAR_PROFISSOES = `dadoscomum/profissoes`;
    const response = await instance.get(LISTAR_PROFISSOES);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_profissoes"],
    refetchOnMount: true,
    enabled: false,
  });
  return query;
}
